import React from 'react';
import PropTypes from 'prop-types';
import { queryModule } from 'iguazu-holocron';
import { connectAsync } from 'iguazu';

import TermsAndConditions from '../TermsAndConditions';

export const LegalFooter = ({
  isLoading, loadedWithErrors, locale, langPack, Legal,
}) => {
  if (isLoading()) {
    return null;
  }
  if (loadedWithErrors()) {
    return <div>Footer failed to load some of its asynchronous data</div>;
  }
  return (
    <section aria-label="footer and t&c" className="margin-1-tb">
      {Legal && <Legal params={locale} />}
      <TermsAndConditions locale={locale} langPack={langPack} />
    </section>
  );
};

LegalFooter.propTypes = {
  isLoading: PropTypes.func.isRequired,
  loadedWithErrors: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  langPack: PropTypes.shape({}).isRequired,
  Legal: PropTypes.func.isRequired,
};

export const loadDataAsProps = ({ store: { dispatch }, ownProps }) => (
  ownProps && ownProps.langPack && ownProps.langPack.showAbta
    ? { Legal: () => dispatch(queryModule('axp-travel-agent-legal')) } : ''
);

export default connectAsync({ loadDataAsProps })(LegalFooter);
